// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderStyle_header__3nCRv","welcome":"HeaderStyle_welcome__2AlYC","pageLogo2Gether":"HeaderStyle_pageLogo2Gether__1VH4X"};